__turbopack_context__.v({
  "eyebrow": "Heading-module-scss-module__UPpEgW__eyebrow",
  "textDecoration-line-through": "Heading-module-scss-module__UPpEgW__textDecoration-line-through",
  "textDecoration-underline": "Heading-module-scss-module__UPpEgW__textDecoration-underline",
  "textTransform-capitalize": "Heading-module-scss-module__UPpEgW__textTransform-capitalize",
  "textTransform-lowercase": "Heading-module-scss-module__UPpEgW__textTransform-lowercase",
  "textTransform-uppercase": "Heading-module-scss-module__UPpEgW__textTransform-uppercase",
});
